import { render, staticRenderFns } from "./PostulantsDetails.vue?vue&type=template&id=af7eac16&"
import script from "./PostulantsDetails.vue?vue&type=script&lang=js&"
export * from "./PostulantsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports